var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.app_name == 'KEY LEARNING')?_c('section',[_c('Home')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }